<template>
    <div>
        <div class="card mb-3">
            <div class="card-header">
                反馈模板信息与规则
            </div>
            <table class="table table-bordered mb-0">
                <tbody>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">模板名称</th>
                    <td class="text-left align-middle" style="width: 40%">{{surveyTemplateInfo.surveyTemplateName}}</td>
                    <th class="text-center align-middle" style="width: 10%">模板类型</th>
                    <td class="text-left align-middle" style="width: 40%">{{surveyTemplateInfo.surveyTemplateTypeName}}</td>
                </tr>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">计算规则</th>
                    <td class="text-left align-middle" colspan="3">
                        <ul class="mb-0">
                            <li>
                                <template v-if="surveyTemplateInfo.excludeMaxCount===0 && surveyTemplateInfo.excludeMinCount===0">
                                    计算客观评价分数时，按所有提交的评价分数取平均值
                                </template>
                                <template v-else>
                                    计算客观评价分数时，按所有提交的评价分数，
                                    <template v-if="surveyTemplateInfo.excludeMaxCount !== 0">去掉{{surveyTemplateInfo.excludeMaxCount}}个最高分，</template>
                                    <template v-if="surveyTemplateInfo.excludeMinCount !== 0">去掉{{surveyTemplateInfo.excludeMinCount}}个最低分，</template>
                                    取平均值
                                </template>
                            </li>
                            <li>
                                所有客观评价项{{surveyTemplateInfo.allowAllFullScore? '允许': '不允许'}}全部是满分
                            </li>
                            <li v-if="surveyTemplateInfo.requiredLessThenMinScore">
                                当客观评价项的分值低于最大分值的{{surveyTemplateInfo.minScore}}%时，必须对该项填写主观评价说明
                            </li>
                        </ul>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col-6">反馈模板反馈项信息</div>
                    <div class="col-6 text-right">客观项合计总分：{{totalScore}}</div>
                </div>
            </div>
            <div class="card-body" v-if="surveyTemplateItemData.length===0">
                <div class="alert alert-warning mb-0">没有具体评价内容</div>
            </div>
            <table v-else class="table table-bordered mb-0">
                <thead>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">序号</th>
                    <th class="text-center align-middle" style="width: 70%">内容</th>
                    <th class="text-center align-middle" style="width: 10%">类型</th>
                    <th class="text-center align-middle" style="width: 10%">分值</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(content, index) in surveyTemplateItemData" :key="content.surveyTemplateItemId">
                    <td class="text-center align-middle">{{index+1}}</td>
                    <td class="text-left align-middle">{{content.surveyTemplateItem}}</td>
                    <td class="text-center align-middle">{{content.surveyTemplateItemTypeName}}</td>
                    <td class="text-center align-middle">{{content.surveyTemplateItemType===1? content.maxScore: ''}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import dictionary from "@/utils/dictionary";
import studyApi from "@/utils/api/study";
export default {
    name: "SurveyTemplateView",
    props: {
        surveyTemplateId: {type: String, required: true},
    },
    data: function () {
        return {
            surveyTemplateInfo: {},
            surveyTemplateItemData: [],
        };
    },
    computed: {
        totalScore() {
            let result = 0;
            for (let item of this.surveyTemplateItemData) {
                if (item.surveyTemplateItemType === dictionary.surveyTemplateItemType.V1_SCORE) {
                    result += item.maxScore;
                }
            }
            return result;
        }
    },
    mounted() {
        this.getSurveyTemplateInfo();
        this.getSurveyTemplateItemData();
    },
    methods: {
        getSurveyTemplateInfo() {
            studyApi.survey.template.getSurveyTemplateInfo(this.surveyTemplateId).then(res => {
                this.surveyTemplateInfo = res.data;
            });
        },
        getSurveyTemplateItemData() {
            studyApi.survey.template.item.getSurveyTemplateItemData(this.surveyTemplateId).then(res => {
                this.surveyTemplateItemData = res.data;
            });
        },
    }
}
</script>

<style scoped>

</style>